import { INetZeroDetailFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';

type MasterDataType = {
  id: number;
  nameTh: string;
  nameEn: string;
};

const findMasterData = (
  id: number | string | undefined,
  masterData: MasterDataType[]
) => masterData.find((data) => data.id === id);

export const mapNetZeroToTable = (
  netZeroDetails: INetZeroDetailFormValues[],
  netZeroMasterData: MasterDataType[]
) => {
  return netZeroDetails.map((detail, index) => {
    const scopeData = findMasterData(detail.scopeId, netZeroMasterData);
    const tgoData = findMasterData(detail.tgoId, netZeroMasterData);
    const sbtiData = findMasterData(detail.sbtiId, netZeroMasterData);

    return {
      ...detail,
      id: detail.id ?? `NEW-${index + 1}`,
      scope: {
        scopeId: detail.scopeId,
        nameScopeTh: scopeData?.nameTh,
        nameScopeEn: scopeData?.nameEn,
      },
      acceptance: {
        isTgo: detail.isTgo,
        nameTgoTh: tgoData?.nameTh,
        nameTgoEn: tgoData?.nameEn,
        isSbti: detail.isSbti,
        nameSbtiTh: sbtiData?.nameTh,
        nameSbtiEn: sbtiData?.nameEn,
      },
    };
  });
};
